import { useEffect, useState, useRef, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useReducedMotion } from '../hooks/useReducedMotion';
import { cn } from './ui/utils';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

export function PageTransition({ children, className }: PageTransitionProps) {
  const location = useLocation();
  const prefersReducedMotion = useReducedMotion();
  const [isVisible, setIsVisible] = useState(true);
  const previousPathRef = useRef(location.pathname);

  useEffect(() => {
    // Check if pathname actually changed
    if (location.pathname !== previousPathRef.current) {
      previousPathRef.current = location.pathname;

      if (!prefersReducedMotion) {
        setIsVisible(false);
        // Small delay before showing new content
        const timeout = setTimeout(() => {
          setIsVisible(true);
        }, 50);
        return () => clearTimeout(timeout);
      }
    }
  }, [location.pathname, prefersReducedMotion]);

  if (prefersReducedMotion) {
    return <div className={cn('h-full', className)}>{children}</div>;
  }

  return (
    <div
      className={cn(
        'transition-all duration-200 ease-out h-full',
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2',
        className
      )}
    >
      {children}
    </div>
  );
}
